// extracted by mini-css-extract-plugin
module.exports = {"headline":"headline_headline__O7cF_","white":"headline_white__1wTW4"};